import moment from 'moment-timezone';
import Vue from 'vue';
moment.locale('ja');
Vue.prototype.$moment = moment;
